function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//

import * as echarts from 'echarts';
import T from './echarts-theme-T.js';
import 'echarts-liquidfill';
echarts.registerTheme('T', T);
var unwarp = function unwarp(obj) {
  return obj && (obj.__v_raw || obj.valueOf() || obj);
};
import { EventBus } from '@/libs/bus';
export default _objectSpread(_objectSpread({}, echarts), {}, {
  name: 'scEcharts',
  props: {
    height: {
      type: String,
      default: '100%'
    },
    width: {
      type: String,
      default: '100%'
    },
    nodata: {
      type: Boolean,
      default: false
    },
    option: {
      type: Object,
      default: function _default() {}
    },
    field: {
      type: Object,
      default: function _default() {}
    },
    designer: {
      type: Object,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      isActivat: false,
      myChart: null
    };
  },
  inject: ['previewState'],
  watch: {
    option: {
      deep: true,
      handler: function handler(v) {
        var _unwarp, _unwarp2;
        (_unwarp = unwarp(this.myChart)) === null || _unwarp === void 0 ? void 0 : _unwarp.clear();
        (_unwarp2 = unwarp(this.myChart)) === null || _unwarp2 === void 0 ? void 0 : _unwarp2.setOption(v);
      }
    }
  },
  computed: {
    myOptions: function myOptions() {
      return this.option || {};
    }
  },
  activated: function activated() {
    var _this = this;
    if (!this.isActivat) {
      this.$nextTick(function () {
        _this.myChart.resize();
      });
    }
  },
  deactivated: function deactivated() {
    this.isActivat = false;
  },
  mounted: function mounted() {
    var _this2 = this;
    this.isActivat = true;
    setTimeout(function () {
      _this2.draw();
    }, 500);
  },
  methods: {
    draw: function draw() {
      var _this3 = this;
      var myChart = echarts.init(this.$refs.scEcharts, 'T');
      myChart.setOption(this.myOptions);
      this.myChart = myChart;
      if (['barXChart', 'barChart', 'pieChart'].includes(this.field.type) && this.previewState) {
        this.myChart.on('click', function (params) {
          if (_this3.field.type === 'pieChart') {
            var _params$data;
            if (!params.data.dim_value) return _this3.$message.warning('暂无更多数据');
            EventBus.$emit('pieChangeValue', ((_params$data = params.data) === null || _params$data === void 0 ? void 0 : _params$data.dim_value) || '');
          } else if (_this3.myOptions.other && !Array.isArray(_this3.myOptions.other) && _this3.myOptions.other.dim_value) {
            if (!_this3.myOptions.other.dim_value[params.dataIndex]) return _this3.$message.warning('暂无更多数据');
            var name = _this3.field.type == 'barChart' ? 'barChangeValue' : 'barXChangeValue';
            EventBus.$emit(name, _this3.myOptions.other.dim_value[params.dataIndex] || '');
          }
        });
      }
    }
  }
});